import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-2">
          热门视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          深度解说与独家访谈，用影像还原事件全貌
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-44 md:h-48 object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-[11px] whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 mb-1 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                  {item.desc}
                </p>
                <span className="text-[11px] text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}